import { render, staticRenderFns } from "./Ball.vue?vue&type=template&id=42668f98&"
import script from "./Ball.vue?vue&type=script&lang=js&"
export * from "./Ball.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports